"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUiInformationBase = void 0;
const mobileConnector_1 = require("../mobileConnector");
const React = __importStar(require("react"));
const NOTCH_ZERO = 0;
const useUiInformationBase = (mobileConnector) => {
    const [notchSize, setNotchSize] = React.useState(NOTCH_ZERO);
    const [darkMode, setDarkMode] = React.useState(false);
    const isHybridRef = React.useRef(false);
    React.useEffect(() => {
        if ((0, mobileConnector_1.isWebViewPlatform)()) {
            mobileConnector.getDeviceInfo().then((value) => {
                const deviceInfo = JSON.parse(value);
                setNotchSize(deviceInfo.top_margin || deviceInfo.notch || NOTCH_ZERO);
                setDarkMode(deviceInfo.dark_mode || false);
            });
            isHybridRef.current = true;
        }
    }, []);
    return { notchSize, darkMode, isHybrid: isHybridRef.current };
};
exports.useUiInformationBase = useUiInformationBase;
//# sourceMappingURL=useUiInformationBase.js.map